import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { SessionImageCandidateDTO } from '../../../../api/generated';
import { SelfServiceImageSelector } from './SelfServiceImageSelector';

interface OcInsightsImageSelectorDialogProps {
  isMobile: boolean;
  open: boolean;
  onClose: () => void;
  images: SessionImageCandidateDTO[];
  selectedCaptureStartAt: string | null;
  processingCount: number;
  onSelect: (captureStartAt: string) => void;
  onSelectNone: () => void;
}

export function OcInsightsImageSelectorDialog({
  isMobile,
  open,
  onClose,
  images,
  selectedCaptureStartAt,
  processingCount,
  onSelect,
  onSelectNone,
}: OcInsightsImageSelectorDialogProps): ReactElement {
  const { t } = useTranslation();

  return (
    <Dialog
      fullScreen={isMobile}
      fullWidth
      maxWidth='xs'
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            width: { sm: 420 },
            maxWidth: { sm: 'calc(100% - 48px)' },
            display: 'flex',
            flexDirection: 'column',
          },
        },
      }}
    >
      <DialogTitle>{t('selfService.selectImage')}</DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          minHeight: 0,
          overflow: 'hidden',
          p: { xs: 2, md: 3 },
        }}
      >
        <SelfServiceImageSelector
          images={images}
          selectedCaptureStartAt={selectedCaptureStartAt}
          processingCount={processingCount}
          onSelect={onSelect}
          onSelectNone={onSelectNone}
        />
      </DialogContent>
    </Dialog>
  );
}
